import { render, staticRenderFns } from "./CoursesAnalytics.vue?vue&type=template&id=5af3ac6c&"
import script from "./CoursesAnalytics.vue?vue&type=script&lang=js&"
export * from "./CoursesAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports